/**
 * InstalmentsPage — Batch #14.325 / #14.329 : /admin/acomptes (hub Cabinet) = MES acomptes provisionnels de travailleur autonome.
 * Les acomptes des clients se calculent dans leur dossier : Fiscal (particuliers) · Tenue de livres (autonome ou société).
 */
import { CalendarRange } from "lucide-react";
import InstalmentsCalculator from "@/components/instalments/InstalmentsCalculator";

export default function InstalmentsPage() {
  return (
    <div className="space-y-4 p-4 sm:p-6 max-w-6xl mx-auto" data-testid="instalments-page">
      <div className="bg-gradient-to-r from-violet-50 via-violet-50 to-white border-2 border-violet-200 rounded-2xl p-5 sm:p-6 shadow-sm flex items-start gap-3">
        <div className="w-11 h-11 rounded-xl bg-violet-600 text-white flex items-center justify-center shadow"><CalendarRange className="w-6 h-6" /></div>
        <div className="flex-1 min-w-0">
          <h1 className="text-lg sm:text-xl font-bold text-slate-900">Mes acomptes provisionnels</h1>
          <p className="text-xs text-slate-600 mt-0.5">Travailleur autonome : revenu brut estimé − dépenses estimées, province d'emploi, âge (RRQ), AE facultative → impôt fédéral et provincial, RRQ doublé, RRQ2, RQAP, résultat et échéancier au trimestre (15 mars · 15 juin · 15 septembre · 15 décembre), PDF. Les acomptes de vos clients se calculent dans leur dossier (Fiscal pour les particuliers · Tenue de livres pour les travailleurs autonomes et sociétés).</p>
        </div>
      </div>
      <InstalmentsCalculator scope="cabinet" defaultName="" />
    </div>
  );
}
